import React, {Component, useState, useEffect} from "react";
import firebase from "firebase";
import {
    MDBDropdown,
    MDBNavbar,
    MDBNavbarBrand,
    MDBDropdownToggle,
    MDBNavbarToggler,
    MDBCollapse,
    MDBDropdownMenu, MDBNavbarNav,
    MDBDropdownItem, MDBNavItem,
    MDBBtn, MDBInputGroup, MDBNavLink, MDBFormInline
} from 'mdbreact';
import classes from './Heading.module.css'
import common from '../../Utils/common.module.css'
import {
    faArrowLeft,
    faBell,
    faClipboardList,
    faLanguage, faSearch,
    faUserCircle
} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import { Capacitor} from '@capacitor/core';
import {Link, withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {Trans} from "react-i18next";
import {useTranslation} from "react-i18next";

import logo from '../../Assets/logo.png'
import {isAuth} from "../../Utils/firebaseUtils";
import {getAPIPath} from "../../Utils/HelpingFunction";

const Heading = (props) => {
    const {t, i18n} = useTranslation()
    const [isOpen, setIsOpen]= useState(false)
    const [isAdmin, setIsAdmin] = useState(false)
    const [isOpenLang, setIsOpenLang] = useState(localStorage.getItem('i18n-lang') === null)


    useEffect(() => {
        if(isAuth(props.auth)){
            firebase.auth().currentUser.getIdTokenResult()
                .then((idTokenResult) => {
                    setIsAdmin(idTokenResult.claims.type === "administrator")
                })
        }
    }, [props.auth])

    const onSetNotificationPref = () =>  {
        console.log('hi')
        if (!("Notification" in window)) {
            alert("This browser does not support desktop notification");
        }

        // Let's check whether notification permissions have already been granted
        else if (Notification.permission === "granted") {
            console.log('hihi')
            // If it's okay let's create a notification
            const messaging = firebase.messaging();
            messaging.getToken({vapidKey: "BE7FT7GwqwzVasd6Htn8qLEWHaAR3hi-cdHGe7vBR_sj8khdWeUIbwqdii_rVQR0JVFX5l4i2p6mAFkrNaGP1V8"}).then((currentToken) => {
                if (currentToken) {
                    if (localStorage.getItem('mewesearcher-gcm-id') !== currentToken  && Capacitor.getPlatform() === "web") {
                        localStorage.setItem('mewesearcher-gcm-id', currentToken);
                        return new Promise(async (resolve, reject) => {
                            await fetch(getAPIPath("/api/gcm/addID"), {
                                method: 'POST',
                                headers: {"Content-Type": "application/json"},
                                body: JSON.stringify({
                                    id: currentToken,
                                })
                            })
                                .then((res) => res.json()).then((response) => {
                                    if (response.success) {

                                    }

                                })
                        })
                    }

                } else {
                    // Show permission request.
                    console.log('No registration token available. Request permission to generate one.');
                    // Show permission UI.

                }
            })
            firebase.analytics().logEvent('messaging_permission_accepted');
            var notification = new Notification("Hi 我地之後會係呢到通知你正嘅MeWe Group/ Page");
        }

        // Otherwise, we need to ask the user for permission
        else if (Notification.permission !== "denied") {
            console.log('hihihi')
            firebase.analytics().logEvent('messaging_permission_rejected');

            Notification.requestPermission().then(function (permission) {
                // If the user accepts, let's create a notification
                if (permission === "granted") {
                    const messaging = firebase.messaging();
                    messaging.getToken({vapidKey: "BE7FT7GwqwzVasd6Htn8qLEWHaAR3hi-cdHGe7vBR_sj8khdWeUIbwqdii_rVQR0JVFX5l4i2p6mAFkrNaGP1V8"}).then((currentToken) => {
                        if (currentToken) {
                            if (localStorage.getItem('mewesearcher-gcm-id') !== currentToken  && Capacitor.getPlatform() === "web") {
                                localStorage.setItem('mewesearcher-gcm-id', currentToken);
                                return new Promise(async (resolve, reject) => {
                                    await fetch(getAPIPath("/api/gcm/addID"), {
                                        method: 'POST',
                                        headers: {"Content-Type": "application/json"},
                                        body: JSON.stringify({
                                            id: currentToken,
                                        })
                                    })
                                        .then((res) => res.json()).then((response) => {
                                            if (response.success) {

                                            }

                                        })
                                })
                            }

                        } else {
                            // Show permission request.
                            console.log('No registration token available. Request permission to generate one.');
                            // Show permission UI.

                        }
                    }).catch((err) => {
                        console.log('An error occurred while retrieving token. ', err);

                    });
                    firebase.analytics().logEvent('messaging_permission_accepted');
                    var notification = new Notification("Hi 我地之後會係呢到通知你正嘅MeWe Group/ Page");
                }
            });
        }
    }

    return(
        <div className={classes.HeadingBar}>
            <header>
                <MDBNavbar className={classes.Heading} dark expand="md">
                    {
                        props.location.pathname !== '/' &&
                        <button className={common.HeadingBackBtnFixed}
                                onClick={(e) => {
                                    props.history.goBack()
                                }}
                        >
                            <FontAwesomeIcon icon={faArrowLeft}/>

                        </button>
                    }
                    
                    {/*{*/}
                    {/*    props.location.pathname !== '/' ?*/}
                    {/*        <button*/}
                    {/*            className={common.BackBtn}*/}
                    {/*            onClick={(e) => {*/}
                    {/*                props.history.goBack()*/}
                    {/*            }}*/}
                    {/*        >*/}
                    {/*            <FontAwesomeIcon icon={faArrowLeft}/>*/}
                    
                    {/*        </button>*/}
                    {/*        : ''*/}
                    {/*}*/}
                    <MDBNavbarBrand className={classes.Branding}>
                        <Link to={{pathname: '/'}}>
                            <img src={logo} alt={'mewe, mewe page, mewe group'}/>
                        </Link>
                    </MDBNavbarBrand>

                    <MDBCollapse isOpen={isOpen} navbar className={classes.MobileCollapse}>
                        <MDBNavbarNav left>
                            {/*{*/}
                            {/*    props.auth.isEmpty ?*/}
                            {/*        <MDBNavItem className={classes.ButtonItem}>*/}
                            {/*            <MDBNavLink className="waves-effect waves-light"*/}
                            {/*                        to={{pathname: '/login'}}>*/}

                            {/*                <FontAwesomeIcon icon={faKey} className={classes.Icon}/>*/}
                            {/*                <span className={classes.ButtonItemText}>登入</span>*/}

                            {/*            </MDBNavLink>*/}
                            {/*        </MDBNavItem>*/}
                            {/*        :*/}
                            {/*        ''*/}
                            {/*}*/}

                            {
                                isAdmin &&
                                <MDBNavItem className={classes.ButtonItem}>
                                    <MDBNavLink className="waves-effect waves-light"
                                                to={{pathname: '/admin/portal'}}>

                                        <FontAwesomeIcon icon={faClipboardList} className={classes.Icon}/>
                                        <span className={classes.ButtonItemText}>Portal</span>

                                    </MDBNavLink>
                                </MDBNavItem>
                            }

                            {
                                !props.location.pathname.includes('/search')&&
                                <MDBNavItem className={classes.SearchItem}>
                                    <MDBNavLink className="waves-effect waves-light"
                                                to={{pathname: '/search'}}>

                                        <input type='text'
                                               placeholder={ "search..."}
                                               onClick={(e) => {
                                                   props.history.push('/search')
                                               }}
                                        />
                                        <FontAwesomeIcon icon={faSearch} className={classes.SearchIcon}/>

                                    </MDBNavLink>
                                </MDBNavItem>
                            }

                            {
                                localStorage.getItem('mewesearcher-gcm-id') === null && Capacitor.getPlatform() === "web" &&
                                <MDBNavItem >
                                    <button className={classes.MessageBtn} onClick={() => onSetNotificationPref()}>
                                        <Trans>Heading.request-noti</Trans>
                                    </button>
                                </MDBNavItem>
                            }



                        </MDBNavbarNav>

                        <MDBNavbarNav right>

                            {/*<MDBNavItem className={classes.ButtonItemDropDownList}>*/}

                            {/*    <MDBDropdown className={classes.UserDropDown}>*/}
                            {/*        <MDBDropdownToggle nav className={classes.UserDropDownToggle}>*/}
                            {/*            <FontAwesomeIcon icon={faBell} className={classes.IconRight}/>*/}

                            {/*        </MDBDropdownToggle>*/}
                            {/*        <MDBDropdownMenu className={classes.DropDownNotification}>*/}
                            {/*            Coming*/}
                            {/*        </MDBDropdownMenu>*/}
                            {/*    </MDBDropdown>*/}

                            {/*</MDBNavItem>*/}

                            <MDBNavItem className={classes.ButtonItemDropDownList}>
                                <MDBDropdown className={classes.UserDropDown}>
                                    <MDBDropdownToggle nav caret className={classes.UserDropDownToggle}>
                                        <FontAwesomeIcon icon={faLanguage} className={classes.IconRight}/>
                                    </MDBDropdownToggle>
                                    <MDBDropdownMenu className={classes.DropDownMenu}>
                                        <MDBDropdownItem className={classes.DropDownItem}>
                                            Language 👇🏼👇🏼
                                        </MDBDropdownItem>
                                        <MDBDropdownItem className={classes.DropDownItem}
                                                         onClick={(e) => {
                                                             console.log(i18n)
                                                             i18n.changeLanguage("hk")
                                                             localStorage.setItem('i18n-lang', "hk");
                                                             window.location.reload(false);
                                                         }}
                                        >
                                            <Trans>Language.lang-hk</Trans>
                                        </MDBDropdownItem>
                                        <MDBDropdownItem className={classes.DropDownItem}
                                                         onClick={(e) => {
                                                             i18n.changeLanguage("en")
                                                             localStorage.setItem('i18n-lang', "en");
                                                             window.location.reload(false);
                                                         }}
                                        >
                                            <Trans>Language.lang-en</Trans>
                                        </MDBDropdownItem>

                                    </MDBDropdownMenu>
                                </MDBDropdown>
                            </MDBNavItem>

                            {
                                !props.auth.isEmpty &&
                                <MDBNavItem className={classes.ButtonItemDropDownList}>
                                    <MDBDropdown className={classes.UserDropDown}>
                                        <MDBDropdownToggle nav caret className={classes.UserDropDownToggle}>
                                            <FontAwesomeIcon icon={faUserCircle} className={classes.IconRight}/>
                                            <span className={classes.ButtonItemTextRight}>
                                                {
                                                    props.auth.isEmpty ?
                                                        "未登入"
                                                        : props.auth.displayName
                                                }
                                            </span>
                                        </MDBDropdownToggle>

                                        {
                                            ! props.auth.isEmpty ?
                                                <MDBDropdownMenu className={classes.DropDownMenu}>
                                                    <MDBDropdownItem className={classes.DropDownItem}>
                                                        <Link
                                                            to={{pathname: '/login'}}>登入
                                                        </Link>
                                                    </MDBDropdownItem>
                                                </MDBDropdownMenu>
                                                :
                                                <MDBDropdownMenu className={classes.DropDownMenu}>
                                                    <MDBDropdownItem className={classes.DropDownItem}
                                                                     onClick={() => firebase.auth().signOut()}>
                                                        <a>
                                                            登出
                                                        </a>
                                                    </MDBDropdownItem>

                                                </MDBDropdownMenu>
                                        }

                                    </MDBDropdown>
                                </MDBNavItem>
                            }

                        </MDBNavbarNav>

                    </MDBCollapse>

                    {
                        localStorage.getItem('mewesearcher-gcm-id') === null  && Capacitor.getPlatform() === "web" &&
                        <MDBNavItem  className={common.HeadingMessageBtnRightFixedLang}>
                            <button className={classes.MessageBtn} onClick={() => onSetNotificationPref()}>
                                <FontAwesomeIcon icon={faBell} className={classes.SearchIcon}/>
                            </button>
                        </MDBNavItem>
                    }

                    <MDBDropdown className={common.HeadingBackBtnRightFixedLang}>
                        <MDBDropdownToggle nav caret className={classes.UserDropDownToggle}>
                            <FontAwesomeIcon icon={faLanguage} className={classes.IconRight}/>
                        </MDBDropdownToggle>
                        <MDBDropdownMenu className={classes.DropDownMenu}>
                            <MDBDropdownItem className={classes.DropDownItem}>
                                Language 👇🏼👇🏼
                            </MDBDropdownItem>
                            <MDBDropdownItem divider />
                            <MDBDropdownItem className={classes.DropDownItem}
                                             onClick={(e) => {
                                                 i18n.changeLanguage("hk")
                                                 localStorage.setItem('i18n-lang', "hk");
                                                 window.location.reload(false);
                                             }}
                            >
                                <Trans>Language.lang-hk</Trans>
                            </MDBDropdownItem>
                            <MDBDropdownItem className={classes.DropDownItem}
                                             onClick={(e) => {
                                                 i18n.changeLanguage("en")
                                                 localStorage.setItem('i18n-lang', "en");
                                                 window.location.reload(false);
                                             }}
                            >
                                <Trans>Language.lang-en</Trans>
                            </MDBDropdownItem>

                        </MDBDropdownMenu>
                    </MDBDropdown>

                    {
                        !props.auth.isEmpty &&
                        <MDBDropdown className={common.HeadingBackBtnRightFixedProfile}>
                            <MDBDropdownToggle nav caret className={classes.UserDropDownToggle}>
                                <FontAwesomeIcon icon={faUserCircle} className={classes.IconRight}/>
                            </MDBDropdownToggle>

                            {
                                props.auth.isEmpty ?
                                    <MDBDropdownMenu className={classes.DropDownMenu}>
                                        <MDBDropdownItem className={classes.DropDownItem}>
                                            <Link
                                                to={{pathname: '/login'}}>登入
                                            </Link>
                                        </MDBDropdownItem>
                                    </MDBDropdownMenu>
                                    :
                                    <MDBDropdownMenu className={classes.DropDownMenu}>
                                        {/*<MDBDropdownItem className={classes.DropDownItem}>*/}
                                        {/*    <Link*/}
                                        {/*        to={{pathname: '/m/profile'}}>我的資料*/}
                                        {/*    </Link>*/}
                                        {/*</MDBDropdownItem>*/}


                                        <MDBDropdownItem className={classes.DropDownItem}
                                                         onClick={() => firebase.auth().signOut()}>
                                            <a>
                                                登出
                                            </a>
                                        </MDBDropdownItem>

                                    </MDBDropdownMenu>
                            }

                        </MDBDropdown>
                    }


                </MDBNavbar>
            </header>
        </div>
    )
}

const enhance = connect(
    ({firebase: {auth, profile}}) => ({
        auth,
        profile
    })
)

export default enhance(withRouter(Heading))